
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "@nullvoxpopuli/ember-composable-helpers/-embroider-implicit-modules.js";
import "ember-cli-typescript/-embroider-implicit-modules.js";
import "ember-auto-import/-embroider-implicit-modules.js";
import "ember-cli-htmlbars/-embroider-implicit-modules.js";
import "ember-cli-sass/-embroider-implicit-modules.js";
import "@sentry/ember/-embroider-implicit-modules.js";
import "@ember/jquery/-embroider-implicit-modules.js";
import "ember-test-selectors/-embroider-implicit-modules.js";
import "@glimmer/tracking/-embroider-implicit-modules.js";
import "qunit-dom/-embroider-implicit-modules.js";
import "ember-classic-decorator/-embroider-implicit-modules.js";
import "ember-decorators/-embroider-implicit-modules.js";
import "ember-intl/-embroider-implicit-modules.js";
import "@square/dashboard-translations/-embroider-implicit-modules.js";
import "@dashboard/i18n/-embroider-implicit-modules.js";
import "@dashboard/query-client/-embroider-implicit-modules.js";
import "@glimmer/component/-embroider-implicit-modules.js";
import "ember-concurrency/-embroider-implicit-modules.js";
import "@square/dashboard-money/-embroider-implicit-modules.js";
import "@square/dashboard-data/-embroider-implicit-modules.js";
import "@dashboard/user/-embroider-implicit-modules.js";
import "@dashboard/assets/-embroider-implicit-modules.js";
import "@ember/render-modifiers/-embroider-implicit-modules.js";
import "ember-svg-jar/-embroider-implicit-modules.js";
import "@square/v-helpers/-embroider-implicit-modules.js";
import "@ember/legacy-built-in-components/-embroider-implicit-modules.js";
import "ember-functions-as-helper-polyfill/-embroider-implicit-modules.js";
import "@square/glass-ui/-embroider-implicit-modules.js";
import "@dashboard/junk-drawer/-embroider-implicit-modules.js";
import "@dashboard/shared-constants/-embroider-implicit-modules.js";
import "@dashboard/user-journeys/-embroider-implicit-modules.js";
import "@html-next/vertical-collection/-embroider-implicit-modules.js";
import "@square-icons/ember/-embroider-implicit-modules.js";
import "@square/dashboard-items-data/-embroider-implicit-modules.js";
import "@square/onboarding/-embroider-implicit-modules.js";
import "@square/react-shim/-embroider-implicit-modules.js";
import "ember-cli-chart/-embroider-implicit-modules.js";
import "ember-cli-string-helpers/-embroider-implicit-modules.js";
import "ember-concurrency-ts/-embroider-implicit-modules.js";
import "@square/dashboard-utilities/-embroider-implicit-modules.js";
import "@square/environment-utils/-embroider-implicit-modules.js";
